if (!window.Eurus.loadedScript.has('featured-collection.js')) {
  window.Eurus.loadedScript.add('featured-collection.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xFeaturedCollection', (sectionId, pageParam, container) => ({
        sectionId: sectionId,
        pageParam: pageParam,
        currentTab: 1,
        loading: true,
        loaded: [],
        carouselCanPrev: false,
        carouselCanNext: false,
        init() {
          document.addEventListener(`eurus:${this.sectionId}:splide-ready`, () => {
            this.bindActiveCarouselArrows();
          });
          this.$nextTick(() => this.bindActiveCarouselArrows());
        },
        select(index) {
          this.currentTab = index;
          this.$nextTick(() => this.bindActiveCarouselArrows());
        },
        getActiveSplide() {
          const panel = document.getElementById(`x-fc-${this.sectionId}-${this.currentTab}`);
          if (!panel) return null;
          const el = panel.querySelector('.x-splide.splide');
          return el && el.splide ? el.splide : null;
        },
        syncCarouselArrows() {
          const splide = this.getActiveSplide();
          if (!splide || !splide.Components || !splide.Components.Controller) {
            this.carouselCanPrev = false;
            this.carouselCanNext = false;
            return;
          }
          const controller = splide.Components.Controller;
          this.carouselCanPrev = controller.getPrev() !== -1;
          this.carouselCanNext = controller.getNext() !== -1;
        },
        bindActiveCarouselArrows() {
          const splide = this.getActiveSplide();
          this.syncCarouselArrows();
          if (!splide || splide.__carouselArrowsBound) return;
          splide.__carouselArrowsBound = true;
          splide.on('moved resized updated', () => this.syncCarouselArrows());
        },
        carouselPrev() {
          const splide = this.getActiveSplide();
          if (!splide) return;
          splide.go('<');
          this.syncCarouselArrows();
        },
        carouselNext() {
          const splide = this.getActiveSplide();
          if (!splide) return;
          splide.go('>');
          this.syncCarouselArrows();
        },
        loadData(index) {
          const selectedPage = index - 1;
          if (!this.loaded.includes(selectedPage)) {
            this.loading = true;
            
            let url = `${window.location.pathname}?section_id=${this.sectionId}&${this.pageParam}=${index}`;
            fetch(url, {
              method: 'GET'
            }).then(
              response => response.text()
            ).then(responseText => {
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const contentId = `x-fc-${this.sectionId}-${index}`;
              const newContent = html.getElementById(contentId);
              if (newContent && !document.getElementById(contentId)) {
                container.appendChild(newContent);
                this.loaded.push(selectedPage);
              }
              this.loading = false;
              this.$nextTick(() => this.bindActiveCarouselArrows());
            })
          }
        },
        scrollIntoView(element) {
          const scrollableContainer = element.closest('.overflow-x-auto'); 
          const elementPosition = element.offsetLeft;

          scrollableContainer.scroll({
            left: elementPosition,
            behavior: 'smooth'
          });
        }
      }));
    });
  });
}
